<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1>Re-review Batches</h1>
        <p class="grey--text">
          Verifier-requested batch reflags. Approving flips
          <code>needs_review=True</code> on every photo matching
          (project, period); rejecting makes no data change.
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-simple-table v-if="rereviewBatches.length">
          <template v-slot:default>
            <thead>
              <tr>
                <th>ID</th>
                <th>Requested by</th>
                <th>Project</th>
                <th>Period</th>
                <th>Reason</th>
                <th>Status</th>
                <th>Affected</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="b in rereviewBatches" :key="b.id">
                <td>#{{ b.id }}</td>
                <td>{{ b.requested_by_name || '—' }}</td>
                <td>{{ b.scope_project_id }}</td>
                <td>{{ formatDate(b.scope_period_start) }} → {{ formatDate(b.scope_period_end) }}</td>
                <td>{{ b.reason }}</td>
                <td>
                  <v-chip small :color="statusColor(b.status)">{{ b.status }}</v-chip>
                </td>
                <td>{{ b.photos_affected_count != null ? b.photos_affected_count : '—' }}</td>
                <td>
                  <template v-if="b.status === 'pending_approval' && isAdmin">
                    <v-btn small color="success" :loading="acting[b.id]" @click="doApprove(b)">Approve</v-btn>
                    <v-btn small color="error" class="ml-1" :loading="acting[b.id]" @click="doReject(b)">Reject</v-btn>
                  </template>
                  <span v-else-if="b.approved_by_name" class="caption grey--text">
                    by {{ b.approved_by_name }}
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <p v-else class="grey--text">No batch requests yet.</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'RereviewBatches',
  data () {
    return { acting: {} }
  },
  computed: {
    ...mapState({
      rereviewBatches: (s) => s.verification.rereviewBatches,
      user: (s) => s.auth.profile.user,
    }),
    isAdmin () { return this.user && this.user.roles && this.user.roles.includes('Sys Admin') },
  },
  mounted () { this.fetchRereviewBatches() },
  methods: {
    ...mapActions(['fetchRereviewBatches', 'approveRereviewBatch', 'rejectRereviewBatch']),
    formatDate (iso) { return iso ? new Date(iso).toISOString().slice(0, 10) : '' },
    statusColor (status) {
      switch (status) {
        case 'pending_approval': return 'warning'
        case 'approved': return 'primary'
        case 'applied': return 'success'
        case 'rejected': return 'grey'
        default: return 'default'
      }
    },
    async doApprove (b) {
      this.$set(this.acting, b.id, true)
      try { await this.approveRereviewBatch(b.id) }
      catch (e) { alert('Approve failed: ' + e.message) }
      finally { this.$set(this.acting, b.id, false) }
    },
    async doReject (b) {
      this.$set(this.acting, b.id, true)
      try { await this.rejectRereviewBatch(b.id) }
      catch (e) { alert('Reject failed: ' + e.message) }
      finally { this.$set(this.acting, b.id, false) }
    },
  },
}
</script>
